module.exports = __webpack_public_path__ + "img/study_stacontent_bg.0fca0faa.png";